import React from 'react';
import styled from 'styled-components';

import Cell from './common/Cell';
import DataCell from './common/DataCell';
import Row from './common/Row';
import MonitorField from './common/MonitorField';
import MonitorLabel from './common/MonitorLabel';

export interface IAudioInfoAreaProps {}

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export default function AudioInfoArea(props: IAudioInfoAreaProps) {
  return (
    <Container>
      <Row>
        <Cell>
          <MonitorLabel field="audio-info-area-1" />
        </Cell>
        <DataCell width="55%" minHeight="20px">
          <MonitorField field="audio-info-area-1" />
        </DataCell>
      </Row>
      <Row>
        <Cell>
          <MonitorLabel field="audio-info-area-2" />
        </Cell>
        <DataCell width="55%" minHeight="20px">
          <MonitorField field="audio-info-area-2" />
        </DataCell>
      </Row>
      <Row>
        <Cell>
          <MonitorLabel field="audio-info-area-3" />
        </Cell>
        <DataCell width="55%" minHeight="20px">
          <MonitorField field="audio-info-area-3" />
        </DataCell>
      </Row>
      <Row>
        <Cell>
          <MonitorLabel field="audio-info-area-4" />
        </Cell>
        <DataCell width="55%" minHeight="20px">
          <MonitorField field="audio-info-area-4" />
        </DataCell>
      </Row>
    </Container>
  );
}
